@use "../../../node_modules/bulma/sass/utilities/_all.sass";
@use "../../styles/fonts";

.label {
    font-size: fonts.$size-5;

    @include all.until (all.$desktop) {
        font-size: fonts.$size-6;
    }
}